import { AxiosResponseHeaders } from 'axios';
import { SwiftBanksResponseDTO, SwiftBank } from '../entities';

const swiftBanksResponseDTOToSwiftBanksAdapter = (
  data: SwiftBanksResponseDTO,
  headers?: AxiosResponseHeaders,
): SwiftBank[] => {
  if (!data.body) {
    throw new Error('Error');
  }

  return data.body.swiftBankResponseDtoList.map(sc => new SwiftBank(sc.bankName));
};

export { swiftBanksResponseDTOToSwiftBanksAdapter };
